<div class="page-container">
  <div class="page-title">
    <span translate="BUTTON.DATAMANAGEMENT"> </span>
    <div class="size-fix">
      <pop-user-card></pop-user-card>
    </div>
  </div>


  <div class="box-layout">
    <h2 translate="DATA_MANAGEMENT.IMPORT"></h2>
    <pop-default-department-selector></pop-default-department-selector>

    <h2 class="margin-top"
        translate="DATA_MANAGEMENT.IMPORT_PROJECT"></h2>
    <pop-project-import></pop-project-import>

    <h2 class="margin-top"
        translate="DATA_MANAGEMENT.EXPORT_PROJECT"></h2>
    <pop-estimate-export></pop-estimate-export>

    <div *ngIf="config?.hasCRM">
      <h2 class="margin-top"
          translate="DATA_MANAGEMENT.EXPORT_TO_GP_SIFIA"></h2>
      <pop-export-to-gp-sifia></pop-export-to-gp-sifia>
    </div>
  </div>

</div>
